import { Box, Button, Divider } from '@mui/material';
import { useToggle } from 'react-use';
import FilterListIcon from '@mui/icons-material/FilterList';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { useSandboxFilters } from 'SandboxModule/hooks/useSandboxFilters';

const SandboxFiltersContainer = () => {
  const [showSandboxFilter, toggleSandboxFilter] = useToggle(false);
  const { SandboxFilter } = useSandboxFilters();

  return (
    <>
      <Box display={'flex'} justifyContent={'flex-end'} mx={3}>
        <Button
          variant="contained"
          color="primary"
          onClick={toggleSandboxFilter}
          startIcon={showSandboxFilter ? <ExpandLessIcon /> : <FilterListIcon />}
        >
          {showSandboxFilter ? 'Collapse' : 'Filter'}
        </Button>
      </Box>
      {showSandboxFilter ? (
        <div>
          <Box display={'flex'} justifyContent={'space-between'} mx={3}>
            {SandboxFilter}
          </Box>
          <Divider />
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default SandboxFiltersContainer;
